import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";

const API_BASE = environment.apiUrl + "numeroWhatsapp";

interface CallTokenResponse {
  instancia: string;
  token: string;
}

/**
 * Armazena as credenciais da sessão (idInstancia + authToken)
 * e expõe o método getCallToken para ser usado pelo Z-API SDK.
 */
@Injectable({ providedIn: "root" })
export class CallTokenService {
  private idInstancia: string = "";
  private authToken: string = "";

  constructor(private http: HttpClient) {}

  /** Armazena as credenciais vindas da URL */
  setCredentials(idInstancia: string, authToken: string): void {
    this.idInstancia = idInstancia;
    this.authToken = authToken;
  }

  /** Retorna o idInstancia atual */
  getInstanceId(): string {
    return this.idInstancia;
  }

  /** Chama o backend para obter o token efêmero do Z-API */
  async getCallToken(): Promise<{ instancia: string; token: string }> {
    if (!this.idInstancia || !this.authToken) {
      throw new Error(
        "Credenciais não configuradas. Acesse via /auth/[idInstancia]/[authToken]",
      );
    }

    const url = `${API_BASE}/getCallToken/${this.idInstancia}`;
    const headers = new HttpHeaders({ Authorization: this.authToken });

    const response = await firstValueFrom(
      this.http.get<CallTokenResponse>(url, { headers }),
    );

    return { instancia: response.instancia, token: response.token };
  }
}
